<div class="stripe-confirmation p-4">
  <h2 class="mb-4">{{ 'stripe_confirm_title' | translate }}</h2>

  <!-- Initializing / Loading -->
  @if (initializing() || loading()) {
    <div class="text-center py-5">
      <c-spinner color="primary"></c-spinner>
      <p class="mt-3">{{ 'stripe_initializing' | translate }}</p>
    </div>
  }

  <!-- Error (no clientSecret or init failed) -->
  @if (!initializing() && !loading() && errorMessage() && !clientSecret()) {
    <c-alert color="danger" class="mb-4">
      <h4 class="alert-heading">{{ 'stripe_error_title' | translate }}</h4>
      <p>{{ errorMessage() }}</p>
      <hr />
      <div class="d-flex gap-2">
        <button cButton color="danger" size="sm" (click)="retry()">
          {{ 'stripe_retry' | translate }}
        </button>
        <button cButton color="secondary" size="sm" (click)="goBack()">
          {{ 'stripe_back' | translate }}
        </button>
      </div>
    </c-alert>
  }

  <!-- Payment Form -->
  @if (!initializing() && clientSecret()) {
    <div class="payment-form">
      <!-- Order Summary -->
      <c-card class="mb-4 shadow-sm">
        <c-card-header>
          <strong>{{ 'stripe_order_summary' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          <div class="d-flex justify-content-between mb-2">
            <span>{{ 'stripe_order_id' | translate }}</span>
            <strong>#{{ orderId }}</strong>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <span>{{ 'payment_subtotal' | translate }}</span>
            <span>{{ totalPrice | currencyAmount: currency }}</span>
          </div>
          <div class="d-flex justify-content-between mb-2 text-body-secondary">
            <span>{{ 'payment_processing_fee' | translate }}</span>
            <span>{{ paymentCosts | currencyAmount: currency }}</span>
          </div>
          <hr class="my-2" />
          <div class="d-flex justify-content-between mb-3">
            <strong>{{ 'stripe_total_amount' | translate }}</strong>
            <strong class="text-primary fs-4">
              {{ totalWithCosts | currencyAmount: currency }}
            </strong>
          </div>
          <div class="d-flex justify-content-between text-body-secondary small">
            <span>{{ 'stripe_mode' | translate }}</span>
            <c-badge [color]="stripeMode() === 'production' ? 'success' : 'warning'">
              {{ stripeMode() === 'production' ? ('stripe_mode_live' | translate) : ('stripe_mode_test' | translate) }}
            </c-badge>
          </div>
        </c-card-body>
      </c-card>

      <!-- Card Input -->
      <c-card class="mb-4 shadow-sm">
        <c-card-header>
          <strong>{{ 'stripe_payment_details' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          <div class="form-group mb-3">
            <label class="form-label">{{ 'stripe_card_information' | translate }}</label>
            <div id="card-element" class="stripe-card-element p-3 bg-dark rounded border"></div>
          </div>

          <!-- Test Mode Info -->
          @if (stripeMode() === 'sandbox') {
            <c-alert color="info" class="mb-0 small">
              <strong>{{ 'stripe_test_mode_title' | translate }}</strong><br />
              {{ 'stripe_test_card_number' | translate }}: 4242 4242 4242 4242<br />
              {{ 'stripe_test_expiry' | translate }}: {{ 'stripe_test_expiry_value' | translate }}<br />
              {{ 'stripe_test_cvc' | translate }}: {{ 'stripe_test_cvc_value' | translate }}
            </c-alert>
          }
        </c-card-body>
      </c-card>

      <!-- Error -->
      @if (errorMessage()) {
        <c-alert color="danger" class="mb-4">
          {{ errorMessage() }}
        </c-alert>
      }

      <!-- Actions -->
      <div class="d-flex gap-3 justify-content-between">
        <button
          cButton
          color="secondary"
          size="lg"
          (click)="goBack()"
          [disabled]="processing()"
        >
          <svg cIcon name="cilArrowLeft" class="me-2"></svg>
          {{ 'stripe_back' | translate }}
        </button>

        <button
          cButton
          color="success"
          size="lg"
          (click)="confirmPayment()"
          [disabled]="!canPay()"
        >
          @if (processing()) {
            <c-spinner size="sm" class="me-2"></c-spinner>
            {{ 'stripe_processing' | translate }}
          } @else {
            <svg cIcon name="cilCreditCard" class="me-2"></svg>
            {{ 'stripe_pay_now' | translate }} {{ totalWithCosts | currencyAmount: currency }}
          }
        </button>
      </div>

      <!-- Security Note -->
      <div class="text-center mt-4 text-body-secondary small">
        <svg cIcon name="cilLockLocked" class="me-1"></svg>
        {{ 'stripe_secured_by' | translate }}
        <img src="https://stripe.com/img/v3/home/social.png" alt="Stripe" height="16" class="ms-1" />
      </div>
    </div>
  }
</div>